import { Component } from "react";
import Select from "react-select";
import { deepEqual } from "../../../utils/object";

export const GENERATOR_STYLES = {
  EMAIL: 1,
  REPORT: 2,
  EXTRACT: 3,
  AGREEMENT: 4
};

export const BLANK_EMAIL_OPTION = {
  uuid: "blank-email",
  caption: "Blank Email",
  name: null,
  style: GENERATOR_STYLES.EMAIL,
  blank: true
};

export default class SettingListSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.items ?? [],
      selected: props.selected
    };
  }

  componentDidUpdate(prevProps) {
    const itemsChanged = !deepEqual(this.props.items, prevProps.items);
    const selectedChanged = !deepEqual(this.props.selected, prevProps.selected);
    const update = {};

    if (itemsChanged) update.items = [...this.props.items];
    if (selectedChanged) update.selected = this.props.selected;

    if (!itemsChanged && !selectedChanged) return;
    
    this.setState(prev => ({
      ...prev,
      ...update
    }));

  }

  get sourceItems() {
    const src = this.state.items.length ? this.state.items : (this.props.items ?? []);
    return [BLANK_EMAIL_OPTION, ...src];
  }

  asOption = (item) => ({
      value: item?.uuid ?? null,
      label: String(item?.caption ?? ""),
      item, // keep full object for easy return
  });

  get flatOptions() {
    return this.sourceItems.map(this.asOption);
  }

  get options() {
    const emailOptions = this.sourceItems
      .filter((item) => item?.style === GENERATOR_STYLES.EMAIL)
      .map(this.asOption);

    const reportOptions = this.sourceItems
      .filter((item) => ![GENERATOR_STYLES.EMAIL, GENERATOR_STYLES.EXTRACT, GENERATOR_STYLES.AGREEMENT].includes(item?.style))
      .map(this.asOption);

    const extractOptions = this.sourceItems
      .filter((item) => item?.style === GENERATOR_STYLES.EXTRACT)
      .map(this.asOption);

    const agreementOptions = this.sourceItems
      .filter((item) => item?.style === GENERATOR_STYLES.AGREEMENT)
      .map(this.asOption);

    return [
      { label: "Email", options: emailOptions },
      { label: "Reports", options: reportOptions },
      { label: "Agreements", options: agreementOptions },
      { label: "Extracts", options: extractOptions },
    ].filter((group) => group.options.length);
  }

  get selectedOption() {
    const selected = this.state.selected?.target?.value ?? this.state.selected;
    if (!selected) return null;

    return this.flatOptions.find((option) => option.value === selected.uuid) ?? null;
  }
  
  
  onChange = (optionOrNull) => {
    const selectedOption = optionOrNull ?? null;
    if (!selectedOption && this.state.selected) {
      this.setState({
        selected: null
      }, this.doPostChange);
      return;
    }

    if (!deepEqual(this.state.selected, selectedOption.item)) {
      this.setState({
        selected: selectedOption.item
      }, this.doPostChange);
    }
  };


  doPostChange = () => {

    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: this.state.selected
        },
      });
    }
  };

  render() {
    return (
      <Select
        id={this.props.id}
        value={this.selectedOption}
        className={this.props.className}
        name={this.props.name}
        onChange={this.onChange}
        classNamePrefix="react-select"
        placeholder=""
        options={this.options}
        isClearable={true}
        isDisabled={this.props.disabled || this.props.isDisabled}
      />
    );
  }
}

